// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"adfb5812","66":"b3d72820","144":"63cc7987","310":"4f50bd18","407":"03998f09","483":"54ec5985","495":"5de643e2","598":"cf9f8862","744":"dac38c9c","757":"13f24fc1","801":"dafa9267","815":"3d310ffa","915":"26e74880"}[chunkId] + ".chunk.js";
};